import React from 'react';
import PropTypes from 'prop-types';
import { PhotoCardsResult } from '../search-state/utils';
import useCustomerPhotosLoader from '../hooks/useCustomerPhotosLoader';

/**
 * Reusable customer photos grid component with infinite scroll
 * @param {Object} props - Component props
 * @returns {JSX.Element} Customer photos grid component
 */
const CustomerPhotosGrid = ({
  mobileItemsPerRow,
  selectedGridItem,
  updateSelectedGridItem,
  variant,
  onPhotoFound,
  filterState,
  filterActions,
}) => {
  const {
    photos,
    hasMore,
    filterLoading,
    handleLoadMore,
  } = useCustomerPhotosLoader(filterState, filterActions, onPhotoFound);

  return (
    <PhotoCardsResult
      hits={photos}
      hasMore={hasMore}
      loading={filterLoading}
      refine={handleLoadMore}
      mobileItemsPerRow={mobileItemsPerRow}
      selectedGridItem={selectedGridItem}
      updateSelectedGridItem={updateSelectedGridItem}
      variant={variant}
      hasFilters={filterState.isFiltered}
    />
  );
};

CustomerPhotosGrid.propTypes = {
  mobileItemsPerRow: PropTypes.number.isRequired,
  selectedGridItem: PropTypes.object,
  updateSelectedGridItem: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
  onPhotoFound: PropTypes.func,
  filterState: PropTypes.object.isRequired,
  filterActions: PropTypes.object.isRequired,
};

export default CustomerPhotosGrid;
